import React from 'react';
import {
  ExpandableNavigationItem,
  ExpandableNavigationItemLink,
  ExpandableNavigationItemIcon,
  ExpandableNavigationItemText,
  ExpandableNavigationItemList,
} from 'app/src/components/ExpandableNavigation';
import { HomeTestIds } from '@trello/webdriverio-tests';
import { useTemplateCategoriesQuery } from '@trello/graphql/generated';
import { trackUe, Noun, Verb } from '@trello/analytics';
import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('templates');

import styles from './navigation.less';

export interface TemplatesTabProps {
  expanded: boolean;
  selected: boolean;
  templateCategory: string;
  href: string;
  onClick: () => void;
  shouldShowNewLozenge?: boolean;
}

interface TemplateCategoryTabProps {
  selected: boolean;
  category: string;
  href: string;
  onClick: () => void;
}

export const TemplatesTab: React.FunctionComponent<TemplatesTabProps> = ({
  expanded,
  selected,
  templateCategory,
  shouldShowNewLozenge,
  ...props
}) => {
  const {
    data: categoriesQuery,
    error: categoriesError,
  } = useTemplateCategoriesQuery();

  const categories =
    (categoriesQuery && categoriesQuery.templateCategories) || [];

  return (
    <ExpandableNavigationItem data-test-id={`${HomeTestIds.Templates}`}>
      <ExpandableNavigationItemLink selected={selected} {...props}>
        <ExpandableNavigationItemIcon iconName={'template-board'} />
        <ExpandableNavigationItemText>
          {format('templates')}
          {shouldShowNewLozenge && (
            <>
              &nbsp;
              <span className={styles.navigationItemNewLozenge}>
                {format('new')}
              </span>
            </>
          )}
        </ExpandableNavigationItemText>
      </ExpandableNavigationItemLink>
      {expanded && Boolean(categories.length) && (
        <ExpandableNavigationItemList>
          {categories.map((category) => (
            <TemplateCategoryTab
              category={category.key}
              selected={category.key === templateCategory}
              key={category.key}
              href={`/templates/${category.key}`}
              onClick={() => {
                trackUe(
                  Noun.HOME,
                  Verb.SHOWS,
                  Noun.TEMPLATE_CATEGORY,
                  '',
                  '',
                  `by clicking ${category.key} in left sidebar`,
                );
              }}
            />
          ))}
        </ExpandableNavigationItemList>
      )}
      {categoriesError && <div>{categoriesError}</div>}
    </ExpandableNavigationItem>
  );
};

const TemplateCategoryTab: React.FunctionComponent<TemplateCategoryTabProps> = ({
  category,
  selected,
  ...props
}) => (
  <ExpandableNavigationItem>
    <ExpandableNavigationItemLink
      selected={selected}
      indented
      small
      quiet
      {...props}
    >
      <ExpandableNavigationItemText>
        {format(category).replace(/&amp;/g, '&')}
      </ExpandableNavigationItemText>
    </ExpandableNavigationItemLink>
  </ExpandableNavigationItem>
);
